import { array, object, string } from 'yup';

import { SummaryFormPresetV1 } from 'types/summary';

import { UserSettings } from '../types';

export const summaryFormPresetsScheme = object({
  name: string<UserSettings.SummaryFormPresets>().required(),
  value: array().of(object()).json().nullable(),
});

export type SummaryFormPresets = {
  name: UserSettings.SummaryFormPresets;
  value: SummaryFormPresetV1[] | null;
};
